import axios from "axios";

export default function setupAxios(axios, store) {
    const checkBaseUrl =
        window.location.hostname == "uat.vietnamnet.vn"
            ? "https://uat-comment.vietnamnet.vn/api"
            : process.env.REACT_APP_API_URL;

    console.log("check-checkBaseUrl : ", checkBaseUrl);
    axios.defaults.baseURL = checkBaseUrl; // process.env.REACT_APP_API_URL
    // axios.interceptors.request.use(
    //   config => {
    //     const {
    //       auth: { authToken }
    //     } = store.getState();
    //
    //     if (authToken) {
    //       config.headers.Authorization = `Bearer ${authToken}`;
    //     }
    //
    //     return config;
    //   },
    //   err => Promise.reject(err)
    // );
}
